document.addEventListener("DOMContentLoaded", function () {
  const scrollable = document.querySelector(".product-form__input--scrollable");

  let isDown = false;
  let startX;
  let scrollLeft;
  let isDragging = false;

  const startDragging = (e) => {
    if (e.target.tagName === "INPUT") {
      return; // Ignore drag initiation on input elements
    }

    isDown = true;
    isDragging = false;
    scrollable.classList.add("dragging");
    startX = e.pageX || e.touches[0].pageX;
    scrollLeft = scrollable.scrollLeft;
    e.preventDefault();
  };

  const stopDragging = () => {
    isDown = false;
    scrollable.classList.remove("dragging");
  };

  const doDrag = (e) => {
    if (!isDown) return;
    e.preventDefault();
    isDragging = true;
    const x = e.pageX || e.touches[0].pageX;
    const walk = (x - startX) * 1.5; // Adjust speed here
    scrollable.scrollLeft = scrollLeft - walk;
  };

  // Attach drag events to the scrollable area
  const attachDragListeners = () => {
    console.log("Attaching drag listeners to the scrollable area...", scrollable);
    
    scrollable.addEventListener("mousedown", startDragging);
    scrollable.addEventListener("mouseup", stopDragging);
    scrollable.addEventListener("mouseleave", stopDragging);
    scrollable.addEventListener("mousemove", doDrag);
  };

  // Detach drag events (if needed for cleanup)
  const detachDragListeners = () => {
     scrollable.removeEventListener("mousedown", startDragging);
    scrollable.removeEventListener("mouseup", stopDragging);
    scrollable.removeEventListener("mouseleave", stopDragging);
    scrollable.removeEventListener("mousemove", doDrag);
  };

  // Attach listeners initially
  attachDragListeners();

  // Listen for the 'variantChanged' event to reattach listeners
  // document.addEventListener('variantChanged', function (event) {
  //   console.log("Variant changed, reattaching listeners...");
  //   // Detach old listeners before reattaching
  //   detachDragListeners();
  //   // Reattach drag listeners to the scrollable area
  //   setTimeout(() => {
  //     attachDragListeners();
  //   }, 1000)
    
  // });
});

